import React, { useCallback, useEffect, useRef } from 'react';
import ReactSelect, { components, GroupBase } from 'react-select';
import { useField } from '@unform/core';

import { ChevronDownIcon } from '../../../assets/svg/SVGComponents';
import { Container, InputError } from './styles';

interface OptionType {
  label: string;
  value: string | number;
}

interface Props {
  name: string;
  dropdownIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  iconLeft?: React.FC<React.SVGProps<SVGSVGElement>>;
  isMulti?: boolean;
  options?: OptionType[];
  [key: string]: any;
}

const Select: React.FC<Props> = ({
  name,
  iconLeft: IconLeft,
  dropdownIcon: Icon,
  isMulti = false,
  ...rest
}) => {
  const selectRef = useRef<any>(null);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: ref => {
        if (isMulti) {
          if (!ref.state.selectValue) {
            return [];
          }
          return ref.state.selectValue.map(
            (option: OptionType) => option.value,
          );
        }
        if (!ref.state.selectValue || ref.state.selectValue.length === 0) {
          return '';
        }
        return ref.state.selectValue[0]?.value;
      },
    });
  }, [fieldName, registerField, isMulti]);

  const DropdownIndicator = useCallback(
    (props: any) => {
      return (
        <components.DropdownIndicator {...props}>
          {Icon ? (
            <Icon width="1.22rem" fill="none" strokeWidth={2} />
          ) : (
            <ChevronDownIcon width="1.22rem" strokeWidth={2} />
          )}
        </components.DropdownIndicator>
      );
    },
    [Icon],
  );

  const Control = useCallback(
    (props: any) => {
      return (
        <components.Control {...props}>
          {IconLeft && (
            <IconLeft
              width="1.33rem"
              stroke="#323650"
              fill="none"
              strokeWidth={2}
            />
          )}
          {props.children}
        </components.Control>
      );
    },
    [IconLeft],
  );

  return (
    <Container>
      <ReactSelect
        defaultValue={defaultValue}
        ref={selectRef}
        classNamePrefix="react-select"
        components={{ DropdownIndicator, Control }}
        isMulti={isMulti}
        theme={theme => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: 'rgba(255,152,0,1)', // cor de foco desejada
            primary25: 'rgba(226,226,226,0.2)', // cor de hover nas opções
          },
        })}
        {...rest}
      />
      {error && <InputError>{error}</InputError>}
    </Container>
  );
};

export default Select;
